import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl md:text-3xl font-heading text-primary-500">
              吃瓜网
            </span>
            <span className="hidden sm:inline text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded-full font-label">
              在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-label whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-label whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-label whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label px-5 py-2 rounded-full transition-colors cursor-pointer"
            >
              我要爆料
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-800"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="text-sm font-label py-2 text-foreground-700 hover:text-primary-500 cursor-pointer">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-label py-2 text-foreground-700 hover:text-primary-500 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-label py-2 text-foreground-700 hover:text-primary-500 cursor-pointer">
              关于我们
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap text-center bg-primary-500 text-background-50 text-sm font-label py-2.5 rounded-full mt-2 cursor-pointer"
            >
              我要爆料
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}